/**
 * @generated SignedSource<<64fddee5b0c618bb3147d5ca71fb4ca5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespYMALItemsCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespProductTileCarousel_user">;
  readonly " $fragmentType": "PdpRespYMALItemsCarousel_user";
};
export type PdpRespYMALItemsCarousel_user$key = {
  readonly " $data"?: PdpRespYMALItemsCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespYMALItemsCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespYMALItemsCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespProductTileCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f2c0bc00851d97ae423cc7241a26d8d3";

export default node;
